/**
 * `tx` из адреса возврата воронки. Только десятичное целое > 0 без ведущих
 * нулей: всё прочее — не наша ссылка, и опрашивать по нему статус незачем.
 */
export const parseTransactionId = (raw: string | null): number | null => {
  if (!raw || !/^[1-9]\d*$/.test(raw)) return null
  const id = Number(raw)
  return Number.isSafeInteger(id) ? id : null
}
